var map = {
	"./currentUser.js": 666,
	"./port.js": 667,
	"./server.js": 668
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;


//////////////////
// WEBPACK FOOTER
// ./src/models nonrecursive \.js$
// module id = 665
// module chunks = 0